export const apiVersionPrefix: string = "/api/v0";

export const locationAutocompleteApiPrefix: string = `${apiVersionPrefix}/autocomplete/lodging`;
export const hotelAvailabilityApiPrefix: string = `${apiVersionPrefix}/hotels/availability`;
export const hotelShopApiPrefix: string = `${apiVersionPrefix}/hotels/shop`;
export const cacheLodgingTokenApiPrefix: string = `${apiVersionPrefix}/cache/lodgingToken`;
export const passengersApiPrefix: string = `${apiVersionPrefix}/passengers`;
export const paymentMethodsApiPrefix: string = `${apiVersionPrefix}/paymentMethods`;
export const rewardsApiPrefix: string = `${apiVersionPrefix}/rewards`;
export const hotelBookApiPrefix: string = `${apiVersionPrefix}/payment`;
export const fetchUserInfoPath: string = `${apiVersionPrefix}/userInfo`;
export const customerDetailsApiPath: string = `${apiVersionPrefix}/customer/details`;
export const analyticsApiPrefix: string = `${apiVersionPrefix}/tracking`;

// Stays
export const staysAvailabilityApiPrefix: string = `${apiVersionPrefix}/stays/availability`;

export const analyticsEventApi: string = `${analyticsApiPrefix}/event`;
export const experimentsApiPrefix: string = `${apiVersionPrefix}/experiments`;

export const userApiPrefix = `${apiVersionPrefix}/user`;
export const travelWalletApiPrefix = `${userApiPrefix}/wallet`;

export const calendarPrefix = `${apiVersionPrefix}/calendar`;
export const calendarHotelsPriceApi = `${calendarPrefix}/hotels/price`;

// Corporate travel
export const fetchPolicies = `${apiVersionPrefix}/policies/details`;
export const hotelLoyaltyApiPrefix = `${apiVersionPrefix}/corporate/hotelLoyalty`;

// User preferences
export const userPreferenceApiPrefix: string = `${apiVersionPrefix}/user/preference`;
export const userHotelPreferencesPath: string = `${userPreferenceApiPrefix}/hotel`;
export const userMetadataPath: string = `${userPreferenceApiPrefix}/metadata`;

// Engagement data stream
export const engagementDataApiPrefix: string = `${apiVersionPrefix}/engagement`;
export const trackEngagementDataPath: string = `${engagementDataApiPrefix}/event`;

// Wishlists
export const wishlistsApiPrefix: string = `${apiVersionPrefix}/travel/wishlists/`;
